export default __webpack_public_path__ + "static/media/Birds_of_Paradise_logo.2ad16b1e.png";